import React, { useEffect } from 'react'
import lens from '../../assets/lens.png'
import gray from '../../assets/gray.jpg'
import Aos from 'aos'
import 'aos/dist/aos.css'

const Test = () => {

  useEffect(()=>{
    Aos.init({duration:2000});
  },[]);

  return (
    <div className='w-full px-40 pb-14 pt-36 ' style={{ backgroundImage: `url(${gray})` }}>
        {/* <div className='flex w-full h-[600px] rounded-xl bg-gradient-to-r from-[#1ad6e0] to-[#35a6e3] shadow-xl shadow-slate-500'>  
            <div className='flex justify-center w-full items-center'>
                <h1 className='font-Bangers text-8xl  text-white'>SnapBox</h1>
            </div>
            <div className='flex justify-center w-full items-center px-36 pt-24'>
                 <div className='bg-white flex items-center justify-center h-full w-full rounded-t-3xl border-b-4 border-[#15bac6]'>
                     <div className='bg-slate-800 w-[150px] h-[230px] flex flex-col gap-5 items-center py-5 px-4 rounded-sm'>
                        <img src={lens} alt='lens' className='w-[20px] h-[20px]'/>
                        <div className='w-full h-[60px] bg-gradient-to-r from-[#02e5da] to-[#0062f5]'></div>
                        <div className='flex flex-col gap-2 items-center justify-center'>
                            <div><h1 className='text-[8px] text-white font-medium'>Collect your photos</h1></div>
                            <div className='h-[12px] w-[80px] bg-gradient-to-r from-slate-400 via-slate-100 to-slate-500'></div>
                        </div>
                     </div>
                 </div>
            </div>
        </div> */}
        <div className='flex items-center justify-center w-full h-[600px]'>
            {/* <img src={lens} alt='lens' className='object-cover h-[300px]' data-aos="zoom-in"/> */}
            <h1 className='text-2xl md:text-5xl font-bold font-Faculty_Font text-nowrap' data-aos="zoom-in" >Launching Soon</h1>
        </div>
    </div>
  )
}

export default Test